import { createImageVariantConfig, util } from './sdkLoader';

export const LISTING_CARD_VARIANTS = [
  { suffix: '', width: 400 },
  { suffix: '-640', width: 640 },
  { suffix: '-2x', width: 800 },
];

export const listingCardImageFields = variantPrefix =>
  LISTING_CARD_VARIANTS.map(variant => `variants.${variantPrefix}${variant.suffix}`);

export const listingCardImageVariantParams = (variantPrefix, aspectRatio) =>
  Object.assign(
    {},
    ...LISTING_CARD_VARIANTS.map(variant =>
      createImageVariantConfig(`${variantPrefix}${variant.suffix}`, variant.width, aspectRatio)
    )
  );

export const LISTING_HERO_INLINE_VARIANTS = [
  'scaled-small',
  'scaled-medium',
  'scaled-large',
  'listing-hero',
  'listing-hero-2k',
];

export const LISTING_HERO_LIGHTBOX_VARIANTS = [...LISTING_HERO_INLINE_VARIANTS, 'scaled-xlarge'];

const LISTING_HERO_SCALE_VARIANTS = [
  { name: 'listing-hero', width: 1600 },
  { name: 'listing-hero-2k', width: 2048 },
];

export const listingHeroImageFields = () =>
  LISTING_HERO_SCALE_VARIANTS.map(variant => `variants.${variant.name}`);

export const listingHeroImageVariantParams = () =>
  Object.assign(
    {},
    ...LISTING_HERO_SCALE_VARIANTS.map(variant => ({
      [`imageVariant.${variant.name}`]: util.objectQueryString({
        w: variant.width,
        fit: 'scale',
      }),
    }))
  );
